import { RootState } from "../../store";

export const getProfileInfoMenu = (state: RootState) => state.getProfileInfo;
